import { render, staticRenderFns } from "./ChangeMenuModalForm.vue?vue&type=template&id=393b99e4"
import script from "./ChangeMenuModalForm.vue?vue&type=script&lang=js"
export * from "./ChangeMenuModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports